import { View } from 'react-native';

const Spacer = ({ heightInPixels, nodeTypeAlias, width }) => {
    return <View style={{ height: parseInt(heightInPixels), width: width }} dataSet={{ umbracoComponentName: nodeTypeAlias }} />;
};

export default Spacer;
